import clsx from 'clsx';
import { ReactNode, useState } from 'react';

export const TRIGGER_HOVER = 'hover';
export const TRIGGER_CLICK = 'click';

export type TooltipProps = {
  className?: string;
  tooltipClassName?: string;
  message: ReactNode | string;
  children?: ReactNode | string;
  trigger?: typeof TRIGGER_CLICK | typeof TRIGGER_HOVER;
  onShow?: () => void;
  onHide?: () => void;
};

export const Tooltip = ({
  className,
  tooltipClassName,
  message,
  children,
  trigger = TRIGGER_HOVER,
  onShow,
  onHide,
}: TooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onDefaultClick = () => {
    trigger === TRIGGER_CLICK && setIsOpen(!isOpen);

    isOpen ? onHide && onHide() : onShow && onShow();
  };

  return (
    <div className={className}>
      <div className="relative flex flex-col items-center group">
        <div
          className="cursor-pointer"
          role="textbox"
          onClick={onDefaultClick}
          onKeyPress={onDefaultClick}
          tabIndex={0}
        >
          {children}
        </div>
        <div
          className={clsx('absolute bottom-0 flex flex-col items-center mb-6', {
            flex: isOpen,
            hidden: !isOpen,
            'group-hover:flex': trigger === TRIGGER_HOVER,
          })}
        >
          <div
            className={clsx(
              'relative z-10 leading-tight whitespace-no-wrap shadow-lg rounded-md',
              tooltipClassName,
              {
                'text-white text-xs bg-gray-600 p-2': !tooltipClassName,
              }
            )}
          >
            {message}
          </div>
          <div
            className={clsx('w-3 h-3 -mt-2 rotate-45 z-10', tooltipClassName, {
              'bg-gray-600': !tooltipClassName,
            })}
          />
        </div>
      </div>
    </div>
  );
};
